import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { createPopper } from '@popperjs/core';
console.log(createPopper); // Ensure it's defined


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
